/**
 * Asynchronously loads the component for Batch
 */

import { lazyLoad } from 'utils/loadable';

export const Reports = lazyLoad(
  () => import('./index'),
  module => {
    return module.Reports;
  },
);
